/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:21
 */
const s = {
    ballDistance: 20.8,
    diameter: 7,
    numRows: 13,
    yMult: 1.137,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [201.1938061370609, 201.52664889569465, 199.25759871630825, 201.644187841143, 201.53743679678948, 199.78740213257913],
        1: [199.79949912881193, 200.3093383448636, 229.55526123033297, 200.89190791715995, 229.3694613840398, 199.28452801832088, 201.86008538296937, 201.75173037854273],
        2: [198.50147643941045, 229.2386699378376, 198.59633321260353, 201.6211027762939, 229.57418161229157, 200.938075617551, 229.3808689873031, 229.4494286610867],
        3: [200.88058853145333, 198.99634685997847, 201.69794407671205, 198.2286009024561, 198.10007897858375, 229.50797301732365, 228.40836446965898, 199.28932341489622],
        4: [198.56166404740762, 229.46225959440878, 201.1196614634659, 226.73108843465474, 229.30836567709076, 227.64798662979868, 229.0751378793436, 226.03670557071862],
        5: [200.4049451482386, 199.0126293750994, 201.93545687725577, 198.47844828477105, 200.83212593917222, 229.58150464631765, 201.40447923070766, 229.44082632045237],
        6: [226.32274132610414, 199.51203465243148, 198.79396834558443, 229.71307668457408, 199.07301609451216, 198.8753176976885, 229.41858229727822, 228.76414419727632],
        7: [198.2476254641852, 201.73411076597026, 229.3546636386955, 198.34687840195838, 200.40346475711993, 228.05869213895727, 226.11506260826363, 228.03449459901503],
        8: [198.45253587442733, 226.63813045719547, 198.5362702897683, 226.23701890980414, 198.22691023971572, 198.16656797372326, 229.42814310655422, 226.92892643066426],
        9: [198.6282821707123, 226.25985135505314, 227.96136182266264, 198.30608664082186, 198.6366933592834, 201.43626466315825, 200.19463519562692, 199.09012744066135],
        10: [199.33280949928837, 226.0756793966456, 228.20867485669183, 198.54610479176685, 199.7280559531951, 201.94670146602746, 227.61710116655405, 229.08007370367844],
        11: [226.88972123012408, 201.5550691643453, 226.22085887304578, 199.57344889219934, 226.14296131604414, 227.0755164673643, 226.3444357522959, 228.69571773140368],
        12: [198.4301525125812, 198.4286259514839, 226.28084691256714, 226.0840264456166, 227.84191769432894, 227.80622315888232, 229.88900364676536, 229.30694607641428],
        13: [198.5067486471145, 226.53272922204746, 198.38171550311975, 198.5374297297237, 226.72486414264483, 226.26861437178312, 199.0184637595834, 229.533004611458],
        14: []
    }
};
export {s as default};
